import api from "api/api";

import { useQuery } from "@tanstack/react-query";
function useFetchData({ url, queryKey, params, enabled = true, onSuccess, onError }) {
  return useQuery({
    queryKey: queryKey,
    queryFn: async () => await api.get(url, params),
    enabled: enabled,
    staleTime: 1000 * 60, // 1 minute
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    onSuccess: onSuccess,
    onError: onError,
    onError: onError,
  });
}

export default useFetchData;
